export enum ACTION_BAR_FORMATS {
  ALL = 'action-bar:all',
  CUT = 'action-bar:cut',
}
